import axios from 'axios'

const httpS3 = axios.create({
  headers: {},
})

export { httpS3, axios }
